import MUIGrid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const Grid = styled(MUIGrid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    '&.MuiGrid-item': {
      width: '100%',
    },
  },
}));

export const Sidebar = styled(MUIGrid)(({ theme }) => ({
  paddingLeft: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    '&.MuiGrid-item': {
      width: '100%',
    },
  },
}));

export const ContentGrid = styled(MUIGrid)(({ theme }) => ({
  '&.MuiGrid-item': {
    width: '100%',
    maxWidth: '66.6667%',
    margin: '0 auto',
  },
  [theme.breakpoints.down('lg')]: {
    '&.MuiGrid-item': {
      maxWidth: '95%',
    },
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    '&.MuiGrid-item': {
      maxWidth: '96%',
    },
  },
}));
